import { errorHandler, successHandler } from "@/utils/functions";
import queryGenerator from "@/utils/queryGenarator";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    list: null,
    agent: null,
    total: null,
    error: "",
    loading: false,
};

export const loadAllAgentPaginated = createAsyncThunk(
    "agent/loadAllAgentPaginated",
    async (arg) => {
        try {
            let query = queryGenerator(arg);
            const { data } = await axios.get(`agent?${query}`);
            return successHandler(data);
        } catch (error) {
            return errorHandler(error);
        }
    }
);

export const loadAllAgent = createAsyncThunk(
    "agent/loadAllAgent",
    async () => {
        try {
            const { data } = await axios.get(`agent?query=all`);
            return successHandler(data);
        } catch (error) {
            return errorHandler(error);
        }
    }
);

export const loadSingleAgent = createAsyncThunk(
    "agent/loadSingleAgent",
    async (id) => {
        try {
            const { data } = await axios.get(`agent/${id}`);
            return successHandler(data);
        } catch (error) {
            return errorHandler(error);
        }
    }
);

export const addAgent = createAsyncThunk(
    "agent/addAgent",
    async (values) => {
        try {
            const { data } = await axios({
                method: "post",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                },
                url: `agent`,
                data: values,
            });

            return successHandler(data, "Agent Created Successfully");
        } catch (error) {
            return errorHandler(error, true);
        }
    }
);

export const updateAgent = createAsyncThunk(
    "agent/updateAgent",
    async ({ id, values }) => {
        try {
            const { data } = await axios({
                method: "put",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                },
                url: `agent/${id}`,
                data: values,
            });
            return successHandler(data, "Agent Updated Successfully");
        } catch (error) {
            return errorHandler(error);
        }
    }
);

export const deleteAgent = createAsyncThunk(
    "agent/deleteAgent",
    async ({ id }) => {
        try {
            const { data } = await axios({
                method: "delete",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                },
                url: `agent/${id}`,
            });

            return successHandler(data, "Agent Deleted Successfully");
        } catch (error) {
            return errorHandler(error, true);
        }
    }
);

export const changeAgentStatus = createAsyncThunk(
    "agent/changeAgentStatus",
    async ({ id, isActive }) => {
        try {
            const { data } = await axios({
                method: "put",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                },
                url: `agent/${id}/active`,
                data: {
                    isActive: isActive ? isActive : "false",
                },
            });

            return successHandler(
                data,
                `Agent ${isActive === "true" ? "activated" : "deactivated"} successfully`
            );
        } catch (error) {
            return errorHandler(error, true);
        }
    }
);

const agentSlice = createSlice({
    name: "agent",
    initialState,
    reducers: {
        clearAgent: (state) => {
            state.agent = null;
        },
        clearAgentList: (state) => {
            state.list = [];
        },
    },
    extraReducers: (builder) => {
        // loadAllAgent
        builder.addCase(loadAllAgent.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(loadAllAgent.fulfilled, (state, action) => {
            state.loading = false;
            state.list = action.payload?.data;
        });
        // loadAllAgentPaginated
        builder.addCase(loadAllAgentPaginated.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(loadAllAgentPaginated.fulfilled, (state, action) => {
            state.loading = false;
            state.list = action.payload?.data?.getAllAgent;
            state.total = action.payload?.data?.totalAgent;
        });
        // addAgent
        builder.addCase(addAgent.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(addAgent.fulfilled, (state) => {
            state.loading = false;
        });
        // loadSingleAgent
        builder.addCase(loadSingleAgent.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(loadSingleAgent.fulfilled, (state, action) => {
            state.loading = false;
            state.agent = action?.payload?.data;
        });
        // deleteAgent
        builder.addCase(deleteAgent.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deleteAgent.fulfilled, (state) => {
            state.loading = false;
        });
        // changeAgentStatus
        builder.addCase(changeAgentStatus.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(changeAgentStatus.fulfilled, (state) => {
            state.loading = false;
        });
    },
});

export default agentSlice.reducer;
export const { clearAgent, clearAgentList } = agentSlice.actions;
